import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface EstabelecimentoItem {
    id: number
    nome: string
    visivel: boolean
}

export interface EstabelecimentoOption {
    id: number
    nome: string
}

export interface EstabelecimentosAplicativo {
    estabelecimentosDoApp: EstabelecimentoItem[]
    todosEstabelecimentos: EstabelecimentoOption[]
    podeEditar: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (isErroBackend(data)) {
        return { codErro: data.codErro, mensagem: data.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterEstabelecimentos = async function (
    authorization: string
): Promise<EstabelecimentosAplicativo | ErroApi> {
    try {
        const response = await api
            .get<EstabelecimentosAplicativo | RespostaErroRaw>(
                "aplicativoDados/ObterEstabelecimentosAplicativo",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as EstabelecimentosAplicativo
    } catch (error) {
        RegistrarLogErro(error, "ObterEstabelecimentosAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const adicionarEstabelecimento = async function (
    authorization: string,
    idEstabelecimento: number
): Promise<EstabelecimentoItem | ErroApi> {
    try {
        const response = await api
            .post<EstabelecimentoItem | RespostaErroRaw>(
                "aplicativoDados/AdicionarEstabelecimentoAplicativo",
                { idEstabelecimento },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as EstabelecimentoItem
    } catch (error) {
        RegistrarLogErro(error, "AdicionarEstabelecimentoAplicativo", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const desassociarEstabelecimento = async function (
    authorization: string,
    idEstabelecimento: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(
                `aplicativoDados/DesassociarEstabelecimentoAplicativo/${idEstabelecimento}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "DesassociarEstabelecimentoAplicativo", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
